import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders, getClientAuth } from "../../utils/common";

import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const deleteUserSession = createAsyncThunk(
  "deleteUserSession",
  async (sessionId, { rejectWithValue, dispatch }) => {
    const { userEmail, token } = getClientAuth();
    const userSessionPayload = { userEmail, token };
    try {
      const response = await axios.delete(
        `${baseUrl}/sessions/${sessionId.session}`,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
            client: sessionId.client ? sessionId.client : "UT",
          },
          withCredentials: true,
        },
      );
      // dispatch(getUserSessions(userSessionPayload));
      dispatch(
        showSnackbar({
          message: "Completed Successfully!",
          severity: "success",
        }),
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Save Failed!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
const deleteUserSlice = createSlice({
  name: "delete-user",
  initialState: {
    isLoading: false,
    deleteUser: "",
    isError: false,
    error: null,
    success: false,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteUserSession.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(deleteUserSession.fulfilled, (state, action) => {
      state.isLoading = false;
      state.deleteUser = action.payload;
      state.success = true;
    });
    builder.addCase(deleteUserSession.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export default deleteUserSlice.reducer;
